import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppointmentComponent from "./components/newAppointment";
import AppointmentPlastic from "./components/newAppointmentPlastic";
import AppointmentCapilar from "./components/newAppointmentCapilar";
import CancelAppointmentComponent from "./components/cancelAppointment";
import FormAppointmentComponent from "./components/formAppointment";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename="">
      <Routes>
        <Route path="/c" element={<App />} />
        <Route path="/c/pedir-cita-previa" element={<AppointmentComponent />} />
        <Route
          path="/c/pedir-cita-plastica"
          element={<AppointmentPlastic />}
        />
        <Route
          path="/c/pedir-cita-capilar"
          element={<AppointmentCapilar />}
        />
        <Route path="/c/formulario" element={<FormAppointmentComponent />} />
        <Route
          path="/c/anular-cita-previa"
          element={<CancelAppointmentComponent />}
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
